<template>
  <div class="video-card-message">
    <YoutubePop v-if="showYoutube" :video-id="youtubeId" @close="showYoutube = false"/>
    <div class="rich_video float-right">
      <div class="video_single">
        <div class="img lightgallery">
          <a @click="showYoutube = true">
            <img :src="content.cards[0].imageUrl" alt="圖片說明">
            <div class="playinfo">
              <span @click="showYoutube =true"/>
            </div>
          </a>
        </div>
        <div class="content">
          <div class="info">
            <h2 class="rich-titlle">{{ content.cards[0].title }}</h2>
            <p class="rich-subtitle">{{ content.cards[0].subtitle }}</p>
          </div>
          <div v-for="(b, index) of content.cards[0].buttons" :key="index" class="rich-btn">
            <button @click="openTargetUrl(b.payload, b.actionType)">
              <a v-if="b.actionType == 'text'">{{ b.title }}</a>
              <a v-if="b.actionType == 'url'" :href="b.payload" style="color:#000;text-decoration: none" target="_blank">{{ b.title }}</a>
              <a v-if="b.actionType == 'email'" style="color:#000;text-decoration: none" :href="b.payload" target="_blank">{{ b.title }}</a>
              <a v-if="b.actionType == 'phone'" style="color:#000;text-decoration: none" :href="b.payload">{{ b.title }}</a>
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YoutubePop from './YoutubePop'
import { getIdFromURL } from 'vue-youtube-embed'
export default {
  components: {
    YoutubePop
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: false
    },
    messageStyling: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      showYoutube: false,
      player: {},
      url: "UBmvMLY7CEY",
    }
  },
  methods: {
    openTargetUrl(payload, actionType) {

      if(actionType == 'text') {
        this.$emit("tag-clicked", payload)
      }

    },
    ready (event) {
      this.player = event.target
    }
  },
  computed: {
    content() {
      var contentData = {}
      contentData = JSON.parse(this.data.msgJson)
      for (let i = 0; i < contentData.cards.length; i++) {
        for (let j = 0; j < contentData.cards[i].buttons.length; j++) {
          if(contentData.cards[i].buttons[j].actionType === 'email'){
            contentData.cards[i].buttons[j].payload = 'mailto:' +
            contentData.cards[i].buttons[j].payload
          } else if (contentData.cards[i].buttons[j].actionType === 'phone') {
            contentData.cards[i].buttons[j].payload = 'tel:' +
            contentData.cards[i].buttons[j].payload
          }
        }
      }
      return contentData;
    },
    youtubeId() {
      return getIdFromURL(this.content.cards[0].videoUrl)
    }
  }
}

</script>

<style scoped>
@import "./styles/videoCardMessage.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/VideoCardMessage.vue